<template>
  <b-card-code
    title="Modifier un Gouvernorat"
    aria-label="Formulaire de modification de gouvernorat"
  >
    <b-card-text>
      <span>Veuillez modifier le nom officiel du gouvernorat. Ce champ est obligatoire.</span>
    </b-card-text>

    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form
        v-if="governorate"
        aria-label="Formulaire de modification de gouvernorat"
        aria-describedby="gov-edit-desc"
      >
        <span
          id="gov-edit-desc"
          class="sr-only"
        >Modifiez le champ pour corriger ou mettre à jour le nom du gouvernorat. Utilisez une désignation officielle et unique.</span>
        <b-row>
          <b-col md="12">
            <b-form-group
              label-for="governorate-name"
              label-class="font-weight-bold"
              description="Nom officiel du gouvernorat. Ce champ est obligatoire."
            >
              <template #label>
                Nom du gouvernorat <span
                  class="text-danger"
                  aria-hidden="true"
                >*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Gouvernorat"
                rules="required"
              >
                <b-form-input
                  id="governorate-name"
                  v-model="governorate.name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Nom du gouvernorat"
                  aria-required="true"
                  :aria-invalid="errors.length > 0 ? 'true' : 'false'"
                  aria-describedby="gov-edit-name-desc"
                />
                <b-form-text
                  id="gov-edit-name-desc"
                  class="sr-only"
                >
                  Saisissez ou modifiez le nom officiel du gouvernorat. Ce champ est obligatoire.
                </b-form-text>
                <small
                  v-if="errors[0]"
                  class="text-danger"
                  role="alert"
                >{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :class="{ 'disabled-cursor': isLoading || !isGovernorateValid }"
              :disabled="isLoading || !isGovernorateValid"
              aria-label="Enregistrer les modifications du gouvernorat"
              @click.prevent="editGovernorate"
            >
              Modifier
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCardText,
  BFormText,
} from 'bootstrap-vue'
import { required } from '@validations'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormText,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      id: '',
      required,
      governorate: { name: '' },
      isLoading: false,
    }
  },
  computed: {
    isGovernorateValid() {
      return (
        this.governorate.name !== ''
      )
    },
  },
  created() {
    this.getGovernorate()
    this.id = this.$route.params.id
  },
  methods: {
    async getGovernorate() {
      this.isLoading = true
      const { data } = await axios.get(`/api/governorates/detail/${this.$route.params.id}`)
      // Defensive mapping: handle different API response structures
      if (data && typeof data === 'object') {
        if ('name' in data) {
          this.governorate = { name: data.name }
        } else if ('governorate' in data && data.governorate && typeof data.governorate === 'object') {
          this.governorate = { name: data.governorate.name || '' }
        } else {
          // fallback: try to find a name property anywhere
          this.governorate = { name: data.name || '' }
        }
      } else {
        this.governorate = { name: '' }
      }
      this.isLoading = false
    },
    async editGovernorate() {
      const success = await this.$refs.simpleRules.validate()
      if (success) {
        try {
          await axios.put(
            `/api/governorates/update/${this.id}/`,
            {
              name: this.governorate.name,
            },
          )
          setTimeout(() => {
            this.showToast('success', 'top-center', 'Gouvernorat modifié avec succés')
          }, 1000)
          this.$router.push('/governorates/')
        } catch (error) {
          setTimeout(() => {
            this.showToast('danger', 'top-center', error.toString())
          }, 1000)
        }
      } else {
        setTimeout(() => {
          this.showToast('danger', 'top-center', 'champ obligatoire ! vérifier votre donnée !')
        }, 1000)
      }
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
